/*!

*/
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import {Provider as StoreProvider} from "react-redux";
import store from "./store.js"; 

import AuthLayout from "layouts/Auth.js";

import TenantLayout from "layouts/Tenant.js";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "assets/css/ovl.css";


const loadingMarkup = (
  <div className = "py-4 text-center">
    <h2>Loading .... </h2>
  </div>
)


ReactDOM.render(
  <Suspense fallback={loadingMarkup}>
  <BrowserRouter>
    <Switch>
    <Route exact path="/">
       <Redirect to="/auth/login" /> 
      </Route>
      <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
      <StoreProvider store = {store} >
     
      <Route path="/tenant" render={(props) => <TenantLayout {...props} />} />
      </StoreProvider>
      <Redirect to="/admin/dashboard" />
    </Switch>
  </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
